export enum SubscriptionPlan {
  Annual = 1,
  Monthly = 2,
}

export enum SubscriptionStatus {
  MonthlyActive = "monthly_active",
  YearlyActive = "yearly_active",
  Canceled = "canceled",
  CancelUpcoming = "cancel_upcoming",
  PaymentFailed = "payment_failed",
  MonthlySkipUpcoming = "monthly_skip_upcoming",
  MonthlySkipping = "monthly_skipping",
}

export enum ProductInterval {
  Monthly = "month",
  Yearly = "year",
}
